import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";

import {
    SpsGrowlerComponent,
    SpsGrowlerOutletComponent,
} from "../components/index";
import { SpsGrowlerInternalComponent } from "../components/growler/sps-growler-internal.component";
import { SpsGrowlerService } from "../services/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsGrowlerComponent,
        SpsGrowlerInternalComponent,
        SpsGrowlerOutletComponent
    ],
    exports: [
        SpsGrowlerComponent,
        SpsGrowlerInternalComponent,
        SpsGrowlerOutletComponent
    ],
})
export class SpsGrowlerModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SpsGrowlerModule,
            providers: [SpsGrowlerService],
        };
    }

    static forChild() {
        return { ngModule: SpsGrowlerModule };
    }
}
